import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { ErrorPageComponent } from '@shared/components/error-page/error-page.component';
import { environment } from 'src/environments/environment';
import { shortUrlPathMatcher, ShortUrlRedirectComponent } from './short-url-redirect';
import { PAGE_TITLE } from '@shared/page-title';
import { NOT_FOUND_CONFIG, NotFoundComponent, NotFoundConfig } from '@shared/error-pages';
import { accountRouteGuard } from './account/account-route.guard';

const routes: Routes = [
  {
    path: 'help',
    loadChildren: () => import('./help/help.module').then(m => m.HelpModule),
    data: {
      [PAGE_TITLE]: 'Help',
    }
  },
  {
    path: 'settings',
    loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
    data: {
      [PAGE_TITLE]: 'Settings',
    }
  },
  {
    path: 'registration/:domain',
    redirectTo: route => `register/self/consent?domain=${encodeURIComponent(route.params.domain)}`,
    pathMatch: 'full',
  },
  {
    path: 'registration',
    redirectTo: `register/self/consent`,
    pathMatch: 'full',
  },
  {
    path: 'register',
    loadChildren: () => import('./register/register.module').then(m => m.RegisterModule),
    data: {
      [PAGE_TITLE]: 'Register',
    }
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
    data: {
      [PAGE_TITLE]: 'Log in',
    }
  },
  {
    path: 'signon',
    loadChildren: () => import('./oauth/oauth.module').then(m => m.OauthModule),
    data: {
      [PAGE_TITLE]: 'Log in',
    }
  },
  {
    path: 'a',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
    data: {
      [PAGE_TITLE]: 'Authorise',
    }
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule),
    canActivate: [ accountRouteGuard ],
    data: {
      [PAGE_TITLE]: 'My Account',
    }
  },
  {
    path: 'error',
    data: {
      [PAGE_TITLE]: 'Error',
    },
    children: [
      {
        path: '',
        component: ErrorPageComponent,
        data: {
          title: 'error.generic.title',
          message: 'error.generic.message',
        },
      },
    ],
  },
  {
    matcher: shortUrlPathMatcher,
    component: ShortUrlRedirectComponent,
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: '**',
    component: NotFoundComponent,
    data: {
      [PAGE_TITLE]: 'Page not found',
      [NOT_FOUND_CONFIG]: <NotFoundConfig>{
        links: [
          {
            href: '/login',
            label: 'Log in to your account'
          },
        ]
      },
    }
  }
];

if (!environment.production) {
  routes.unshift({ path: 'debug', loadChildren: () => import('./debug/debug.module').then(m => m.DebugModule) });
}

const options: ExtraOptions = {
  // Enable this when debugging router behaviour. It's verbose!
  enableTracing: false,
  scrollPositionRestoration: 'enabled',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, options)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
